// src/pages/RegisterPage.js (最终版本 - 使用 Flexbox 布局，集成社会化登录)
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Box, Typography, TextField, Button, CssBaseline } from '@mui/material'; //  精简导入组件
import GoogleIcon from '@mui/icons-material/Google';
import GitHubIcon from '@mui/icons-material/GitHub';

const RegisterPage = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
          setError('');

          // 前端验证
          if (!username) {
              setError('用户名不能为空');
              return;
          }
          if (!email) {
              setError('邮箱不能为空');
              return;
          } else if (!/\S+@\S+\.\S+/.test(email)) { //  简单的邮箱格式验证
              setError('邮箱格式不正确');
              return;
          }
          if (!password) {
              setError('密码不能为空');
              return;
          } else if (password.length < 6) { //  密码最小长度
              setError('密码长度不能少于 6 位');
              return;
          }
          if (password !== confirmPassword) { //  验证密码一致性
              setError('两次输入的密码不一致');
              return;
          }


          try {
              const response = await axios.post('/auth/register', {
                  username: username,
                  email: email,
                  password: password,
              });

              console.log('注册成功:', response.data);
              alert('注册成功！即将跳转到登录页面');
              navigate('/login');
          } catch (error) {
              console.error('注册失败:', error.response?.data?.message || '注册失败');
              setError(error.response?.data?.message || '注册失败');
          }
      };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    创建账号
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2, mb: 4 }}>
                    注册新账号以开始使用。
                </Typography>

                <Box sx={{ width: '100%', mt: 2 }}> {/*  表单和社交登录按钮的容器 */}
                    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mb: 3 }}> {/*  本地注册表单 Box */}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="username"
                            label="用户名"
                            name="username"
                            autoComplete="username"
                            autoFocus //  自动 focus 到用户名输入框
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            error={!!error}
                            helperText={error}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="邮箱地址"
                            name="email"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={!!error}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="密码"
                            type="password"
                            id="password"
                            autoComplete="new-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            error={!!error}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="confirmPassword"
                            label="确认密码"
                            type="password"
                            id="confirmPassword"
                            autoComplete="new-password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            error={!!error}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 1 }} //  调整按钮 margin
                        >
                            注册
                        </Button>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}> {/*  社会化登录按钮 Box，Flex 垂直布局 */}
                        <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 1 }}>
                            或使用以下方式注册
                        </Typography>
                        <Button
                            variant="outlined"
                            startIcon={<GoogleIcon />}
                            onClick={() => { window.location.href = '/auth/google/loading'; }}
                        >
                            使用 Google 注册
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<GitHubIcon />}
                            onClick={() => { window.location.href = '/auth/github/loading'; }}
                        >
                            使用 GitHub 注册
                        </Button>
                    </Box>
                </Box>


                <Box sx={{ mt: 4, textAlign: 'center' }}> {/*  底部链接容器 */}
                    <Typography variant="body2" color="text.secondary">
                        已经有账号了？
                        <Link to="/login" variant="body2" sx={{ ml: 1 }}>立即登录</Link>
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        <Link to="/" variant="body2">返回首页</Link>
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
};


export default RegisterPage;